import {GetterTree} from "vuex";

const getters: GetterTree<RootState, RootState> = {
    isExport () {
        let isExport;

        try {
            isExport = window.self !== window.top;
        } catch (e) {
            isExport = true;
        }

        if(isExport)
        {
            window.document.body.classList.add('export');
        }

        return isExport;
    }
};

export default getters;
